export enum AuthEnum {
  Auth = 'AUTH',
  weakPassword = 'weakPASSWORD'
}

export enum RegisterEnum {
  Register = 'REGISTER'
}


export enum UserStatusEnum {
  waitForVerifyInformation = 'waitForVerifyInformation',
  verified = 'verified',
  Migrate = 'Migrate'
}

export enum DocumentStatus {
  Deleted = 'Deleted',
  Active = 'Active',
}

